import "./frappe/ui/listing.html";

import "./frappe/model/indicator.js";
import "./frappe/ui/filters/filter.js";
import "./frappe/ui/filters/filter_list.js";
import "./frappe/ui/filters/field_select.js";
import "./frappe/ui/filters/edit_filter.html";
import "./frappe/ui/tags.js";
import "./frappe/ui/tag_editor.js";
import "./frappe/ui/like.js";
// import "./frappe/ui/liked_by.html";
import "../html/print_template.html";

import "./frappe/list/base_list.js";
import "./frappe/list/list_view.js";
import "./frappe/list/list_factory.js";

import "./frappe/list/list_view_select.js";
import "./frappe/list/list_sidebar_stat.html";
import "./frappe/list/list_sidebar_group_by.js";
import "./frappe/list/list_view_permission_restrictions.html";

import "./frappe/views/gantt/gantt_view.js";
import "./frappe/views/calendar/calendar.js";
import "./frappe/views/dashboard/dashboard_view.js";
import "./frappe/views/image/image_view.js";
import "./frappe/views/map/map_view.js";
import "./frappe/views/kanban/kanban_view.js";
import "./frappe/views/inbox/inbox_view.js";
import "./frappe/views/file/file_view.js";

import "./frappe/views/treeview.js";
import "./frappe/views/interaction.js";

import "./frappe/views/image/image_view_item_row.html";
import "./frappe/views/image/photoswipe_dom.html";

import "./frappe/views/kanban/kanban_board.html";
import "./frappe/views/kanban/kanban_column.html";
import "./frappe/views/kanban/kanban_card.html";
